var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:['toggle-switch', _vm.smallSize && 'toggle-switch-small']},[_vm._t("default"),_c('span',{class:[
            'toggle-switch-field relative w-100 h-100',
            ("toggle-switch-" + _vm.color),
            _vm.smallSize && 'toggle-switch-field-small'
        ]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }